import { OpeningHoursPeriod } from './stores';

export enum AustralianState {
  ACT = 'ACT',
  NSW = 'NSW',
  QLD = 'QLD',
  SA = 'SA',
  VIC = 'VIC',
  WA = 'WA',
  TAS = 'TAS',
  NT = 'NT',
}

export interface GoogleStoreDetails {
  name: string;
  place_id: string;
  formatted_address: string;
  formatted_phone_number: string;
  opening_hours: {
    weekday_text: string[]; // e.g., "Monday: 8:30 AM – 5:30PM"
    periods: OpeningHoursPeriod[];
  };
  address_components: {
    short_name: string;
    types: string[];
  }[];
  geometry: {
    location: {
      lat: number;
      lng: number;
    };
  };
}

export interface LatLng {
  lat: number;
  lng: number;
}

export interface NearbyStoreParams {
  lat?: number;
  lng?: number;
  placeId?: string;
}
